import { ROUTES_DICTIONARY } from '../shiftTasks/constants';

export default class TasksCtrl {
  constructor(
    Restangular,
    Authentication,
    TaskCollection,
    PersonaCollection,
    ShiftTasksService,
    ShiftTasksTabsService,
    $window,
    $scope,
    $state,
    $rootScope,
    $timeout
  ) {
    'ngInject';

    Object.assign(this, {
      Restangular,
      Authentication,
      TaskCollection,
      PersonaCollection,
      ShiftTasksService,
      ShiftTasksTabsService,
      $window,
      $scope,
      $state,
      $rootScope,
      $timeout,
    });

    $rootScope.$on('TASK-DRAG-START', () => {
      if (!this.dragging) {
        $timeout(() => {
          this.dragging = true;
        });
      }
    });

    $rootScope.$on('TASK-DRAG-END', () => {
      if (this.dragging) {
        $timeout(() => {
          this.dragging = false;
        });
      }
    });

    $scope.$on('socket:reconnect', async () => {
      await PersonaCollection.loadData();
      TaskCollection.loadData();
    });

    this.shiftTasksTabs = ShiftTasksTabsService.tabs;
    this.shouldDisplaySubNavigation = ShiftTasksTabsService.shouldDisplayTabs();
    this.currentTabName = ShiftTasksTabsService.currentTab.value;
  }

  selectTab(value) {
    this.ShiftTasksTabsService.setTabByValue(value);
    this.$state.go(ROUTES_DICTIONARY[value] || 'tasks');
  }

  get allTasks() {
    return this.TaskCollection.allTasks;
  }

  get myTasks() {
    return this.TaskCollection.myTasks;
  }

  get createdTasks() {
    return this.TaskCollection.createdTasks;
  }

  get completedTasks() {
    return this.TaskCollection.completedTasks;
  }

  _dropped(task, column, taskCopy) {
    const user = this.Authentication.user;
    switch (column) {
      case 1:
        task.personas.push({ id: user.id });
        this._uncompleteTask(task);
        break;

      case 2:
        if (task.completed) {
          if (user.isManager || task.personas.find((p) => p.isMe)) {
            this._uncompleteTask(task);
          }
        }
        break;

      case 3:
        this._completeTask(task);
        break;

      default:
        break;
    }

    this.TaskCollection.addOrEditTask(task); // update UI immediately
    this.dragging = false;
    task.put().catch(() => {
      if (taskCopy) this.TaskCollection.addOrEditTask(taskCopy); // if sth goes bad, revert
    });
  }

  _completeTask(task) {
    task.completed = true;
    task.completedDate = new Date();
  }

  _uncompleteTask(task) {
    task.completed = false;
    task.completedDate = null;
  }

  dropped(taskId, fromColumn, toColumn) {
    if (toColumn === fromColumn) return;

    const task = this.allTasks.find((t) => String(t.id) === taskId);
    if (!task) return;

    const taskCopy = this.Restangular.copy(task);
    this._dropped(task, toColumn, taskCopy);
  }
}
